module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iu6sQ"))).then(() => parcelRequire('dJXJK'));